export const SET_MODAL_VISIBILITY = 'set_modal_visibility';
export const MODAL_ERROR = 'modal_error';
